import React from 'react';
import PublicLayout from '../components/PublicLayout';
import {
  Box,
  Typography,
  Container,
  Paper,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  marketingBandSx,
  marketingColor,
} from '../theme/marketingTokens';

export const TermsPage: React.FC = () => {
  const { t } = useTranslation() as { t: (key: string, options?: any) => any };
  const sections = t('public.terms.sections', { returnObjects: true }) as {
    title: string;
    paragraphs?: string[];
    bullets?: string[];
    lines?: string[];
  }[];

  return (
    <PublicLayout>
      <Box>
      {/* Header */}
      <Box
        sx={{
          ...marketingBandSx,
          borderTop: 'none',
          py: 8,
          textAlign: 'center',
        }}
      >
        <Container maxWidth="md">
          <Typography variant="h2" component="h1" gutterBottom fontWeight="bold">
            {t('public.terms.header.title')}
          </Typography>
          <Typography variant="h6" sx={{ color: marketingColor.textSecondary }}>
            {t('public.terms.header.updated', { date: new Date().toLocaleDateString() })}
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="md" sx={{ py: 8 }}>
        {sections.map((section) => (
          <Paper key={section.title} sx={{ p: { xs: 3, md: 4 }, mb: 3 }}>
            <Typography variant="h4" gutterBottom fontWeight="bold">
              {section.title}
            </Typography>
            {section.paragraphs?.map((paragraph, paragraphIndex) => (
              <Typography key={`${section.title}-p-${paragraphIndex}`} variant="body1" paragraph>
                {paragraph}
              </Typography>
            ))}
            {section.bullets && section.bullets.length > 0 && (
              <ul>
                {section.bullets.map((item, itemIndex) => (
                  <li key={`${section.title}-b-${itemIndex}`}>{item}</li>
                ))}
              </ul>
            )}
            {section.lines && section.lines.length > 0 && (
              <Typography variant="body1">
                {section.lines.map((line, lineIndex) => (
                  <React.Fragment key={`${section.title}-line-${lineIndex}`}>
                    {line}
                    {lineIndex < (section.lines?.length ?? 0) - 1 && <br />}
                  </React.Fragment>
                ))}
              </Typography>
            )}
          </Paper>
        ))}
      </Container>
      </Box>
    </PublicLayout>
  );
};

export default TermsPage;
